module.exports = __webpack_public_path__ + "static/media/white-logo.c485f511.png";